


































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { IClient } from "@/models/clients";
import { UserMetaKeys } from "@/data/enums/users";
import { ListDisplayMode } from "@/data/constants";
import { CreateElement } from "vue";
import { DefaultTaxTemplateFilters } from "@/data/filters/tax/index";
import { DefaultTaxTemplateSorters } from "@/data/sorters/tax/index";
import TaxTemplatesProvider from "@/components/app/global/tax/templates//taxTemplatesProvider.vue";
import TaxTemplatesTableView from "@/components/app/global/tax/templates/taxTemplatesTableView.vue";
import TaxTemplatesGridView from "@/components/app/global/tax/templates/taxTemplatesGridView.vue";

@Component({
  components: {
    TaxTemplatesProvider
  }
})
export default class TaxTemplatesListing extends Vue {
  // Props

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: () => () => ({}) })
  public routeFilters!: (
    vm?: TaxTemplatesListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: () => () => ({}) })
  public manualFilters!: (
    vm?: TaxTemplatesListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: () => DefaultTaxTemplateFilters })
  public availableFilters!: (vm?: TaxTemplatesProvider) => IFilter[];

  @Prop({ default: () => DefaultTaxTemplateSorters })
  public availableSorters!: (vm?: TaxTemplatesProvider) => ISorter[];

  // Data
  public displayModeStoragePath = UserMetaKeys.UI_TAX_TEMPLATES_VIEW;
  public displayMode = ListDisplayMode.GRID;

  public declare $refs: {
    taxTemplatesProvider: TaxTemplatesProvider;
  };

  // Computed

  public get isDisplayModeTable() {
    return this.displayMode === ListDisplayMode.TABLE;
  }

  public get isDisplayModeGrid() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get taxTemplatesManualFilters() {
    return {
      ...this.manualFilters,
      ...this.routeFilters(this)
    };
  }

  public get listComponent() {
    return {
      render: (h: CreateElement) => {
        if (this.displayMode === ListDisplayMode.GRID)
          return h(TaxTemplatesGridView);
        return h(TaxTemplatesTableView, {});
      }
    };
  }

  @Watch("manualFilters", { deep: true })
  public onParentFiltersChange() {
    this.$refs.taxTemplatesProvider.reloadData();
  }
}
